import React, { useEffect, useRef } from 'react'
import { useLocaleStore } from '../../Contexts/LocaleContext'
import { useViewStore } from '../../Contexts/ViewContext'
import { useRetorikStore } from '../../Contexts/RetorikContext'
import { capitalizeFirstLetter } from '../../../utils/capitalizeFirstLetter'
import preventEvents from '../../../utils/preventEvents'
import BackButton from '../Common/BackButton'
import OldDashboard from '../Common/OldDashboard'
import Parameters from './Parameters'
import Version from '../Common/Version'
import Dashboard from './Dashboard'

interface ParametersAndDashboardContainerProps {
  handleBack: () => void
  hideMenu: boolean
}

const ParametersAndDashboardContainer = ({ handleBack, hideMenu = false }: ParametersAndDashboardContainerProps): JSX.Element => {
  const translation = useLocaleStore((state) => state.currentTranslations)
  const locale = useLocaleStore((state) => state.locale)
  const menu = useRetorikStore((state) => state.configuration.menu)
  const isWidget = useViewStore((state) => state.isWidget)
  const divRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    divRef?.current && isWidget && preventEvents(null, divRef)
  }, [divRef.current])

  return (
    <div className='rf-w-full rf-h-full rf-flex rf-flex-col rf-py-4 rf-bg-truewhite rf-overflow-y-hidden rf-pointer-events-auto'>
      {/* Back to conversation button */}
      <BackButton title={translation.menu.backconversation} className='rf-px-4 rf-text-sm' handleBack={handleBack} />

      <div ref={divRef} className='rf-w-full rf-flex-rf-flex-col rf-overflow-y-scroll rf-scrollbar-hidden'>
        {/* Dashboard */}
        {!hideMenu && (
          <React.Fragment>
            {menu?.categories?.length ? <Dashboard toggleDashboard={handleBack} /> : <OldDashboard toggleDashboard={handleBack} />}
            <div className='rf-h-6 rf-bg-[#F0F0F0] rf-border-y rf-border-y-menuBorder' />
          </React.Fragment>
        )}

        {/* Parameters container */}
        <div className='rf-w-full rf-px-5 rf-flex rf-flex-col rf-justify-start'>
          {/* Title */}
          <div className='rf-py-4 rf-text-lightgray'>{capitalizeFirstLetter(translation.common.parameters, locale)}</div>

          {/* Parameters */}
          <Parameters handleBack={handleBack} />
        </div>

        <Version isMobile />
      </div>
    </div>
  )
}

export default ParametersAndDashboardContainer
